module.exports = __webpack_public_path__ + "img/SERVICIO-SHOPPER-2.515fc584.png";